module.exports = __webpack_public_path__ + "media/images/products/products/pattern-b2177fecac9adddb0072ab1ecc202c77.png";